var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCouponIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.843 9.65033L10.343 2.15033C10.043 1.85033 9.6263 1.66699 9.16797 1.66699H3.33464C2.41797 1.66699 1.66797 2.41699 1.66797 3.33366V9.16699C1.66797 9.62533 1.8513 10.042 2.15964 10.3503L9.65964 17.8503C9.95964 18.1503 10.3763 18.3337 10.8346 18.3337C11.293 18.3337 11.7096 18.1503 12.0096 17.842L17.843 12.0087C18.1513 11.7087 18.3346 11.292 18.3346 10.8337C18.3346 10.3753 18.143 9.95033 17.843 9.65033ZM4.58464 5.83366C3.89297 5.83366 3.33464 5.27533 3.33464 4.58366C3.33464 3.89199 3.89297 3.33366 4.58464 3.33366C5.2763 3.33366 5.83464 3.89199 5.83464 4.58366C5.83464 5.27533 5.2763 5.83366 4.58464 5.83366Z",
    fill: "#C55600"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouponIcon);
export default __webpack_public_path__ + "static/media/coupon-icon.d6c2216e7625fb1b1f871bab18a90af6.svg";
export { ForwardRef as ReactComponent };